import React, { useCallback } from 'react'
import { ReactDatePickerCustomHeaderProps } from 'react-datepicker'
import DatePickerHeader from './DatePickerHeader'
import { DateSelection } from './types'

export const useDatePickerHeader = ({
  minDate,
  maxDate,
}: {
  minDate: DateSelection
  maxDate: DateSelection
}) => {
  return useCallback(
    (props: ReactDatePickerCustomHeaderProps) => (
      <DatePickerHeader {...props} minDate={minDate} maxDate={maxDate} />
    ),
    [minDate, maxDate]
  )
}
